import styled from 'styled-components';

export const FormikInput = (props) => {
  const {
    type = 'text',
    inputmode = 'numeric',
    name,
    label,
    values,
    length,
    errors,
    handleBlur,
    description,
    handleChange,
    touched,
    descriptionColor,
    required = true
  } = props;

  const isError = touched[name] && errors[name];

  return (
    <CustomInput isError={isError} descriptionColor={descriptionColor}>
      <p className="label">
        {label}
        {required && '*'} :
      </p>
      <div>
        <input
          onBlur={handleBlur}
          onChange={handleChange}
          maxLength={length}
          value={values[name]}
          type={type}
          name={name}
          inputMode={inputmode}
          pattern="[0-9]+"
        />
        <p className="description">{isError ? errors[name] : description}</p>
      </div>
    </CustomInput>
  );
};

const CustomInput = styled.div`
  direction: ltr;
  min-height: 114px;
  @media screen and (min-width: 1024px) {
    position: relative;
    display: grid;
    grid-template-columns: 50% 50%;
    place-content: center;
    .label {
      margin: auto 0 !important;
      font-size: 21px !important;
      font-weight: 400 !important;
      color: #4e4e4e !important;
    }

    input {
      height: 64px !important;
      font-size: 24px !important;
      background: #ffffff !important;
    }

    input:hover {
      border: 1px solid #6f4d9f99;
    }

    .description {
      font-size: 16px !important;
      position: absolute;
      position: absolute;
    }
  }

  input {
    height: 44px;
    text-align: center;
    outline: none;
    width: 100%;
    height: 50px;
    z-index: 0;
    border-radius: 16px;
    background: #f5f5f5;
    border: 1px solid #ffffff;
    border: ${({ isError }) =>
      isError ? '1px solid #D81D5D' : '1px solid #ffffff'};
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.16);
    color: ${({ isError }) => (isError ? '#D81D5D' : '#8D4CD5 !important')};
    font-size: 18px;
    font-family: 'dana-bold';
  }

  input:focus {
    border: 1px solid #6f4d9f99;
  }

  .label {
    font-size: 16px;
    margin-bottom: 16px;
    color: #707070;
  }

  p {
    margin-top: 6px;
    color: #7b7b7b;
    text-align: left;
    font-size: 12px;
  }

  .description {
    color: ${({ isError, descriptionColor }) =>
      isError
        ? '#D81D5D'
        : descriptionColor
        ? `${descriptionColor} !important`
        : '#7b7b7b'};
    text-align: left;
    font-size: 12px;
  }
`;
